<template>
    <div>
        <div class="tool-bar mb10">
            <el-button 
                type="primary" 
                v-if="pageFuncNames.includes('add_label')"  
                size="mini" class="mr10"
                @click="()=>labelMoadl()"
             >
                添加标签
             </el-button>
        </div>
        <div class="data-list">
            <jt-table
                v-loading="dataLoading"
                :data="dataList"
                stripe
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :default-sort = "{prop: 'log_time', order: 'descending'}"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    label="标签ID"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="标签"
                    align="center"
                    min-width="100"
                >
                    <template slot-scope="{ row }">
                        {{row.name}}
                        <span @click="()=>labelMoadl(row)" v-if="pageFuncNames.includes('edit_label')" class="text-color-primary pointer el-icon-edit-outline ver-middle ml6 font16px text-bold"></span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="describe"
                    label="说明"
                    align="center"
                    min-width="100"
                 />
                <el-table-column
                    prop="user_name"
                    label="创建人"
                    align="center"
                    min-width="100"
                 />
               
                <el-table-column
                    prop="ctime"
                    label="创建时间"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.ctime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="edit_name"
                    label="最新修改人"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="mtime"
                    label="最新修改时间"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.mtime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="action"
                    label="操作"
                    align="center"
                    min-width="100">
                    <template slot-scope="{ row }">
                        <div class="tac">
                            <el-button 
                                v-if="row.is_delete ==='0' && pageFuncNames.includes('disable_label')" 
                                type="text"
                                class="text-color-error mr10"
                                @click="()=>changeStatus(row)"
                            >
                                停用
                            </el-button>
                             <el-button 
                                v-if="row.is_delete ==='1' &&pageFuncNames.includes('enable_label')" 
                                type="text"
                                class="text-color-primary mr10"
                                @click="()=>changeStatus(row)"
                            >
                                启用
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </jt-table>
        </div>
    </div>
</template>

<script>
    import API from '@/api/workOrder/conf.js';
    import { workOrderTagModal } from '../modal';
    export default {
        name: "WorkOrderTaglList",
        props:{
            pageFunc:Array,
        },
        data(){
            return {
                dataLoading:false,
                dataList:[],
            }
        },
        computed:{
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
        },
        mounted(){
            this.getList();
        },
        methods:{
            async changeStatus(row){
                this.$confirm(`确认${row.is_delete ==='0'?'停用':'启用'}吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        const params ={
                            id: row.id,
                        };
                        if(row.is_delete ==='0'){
                            await API.disableWorkOrderLabelConfigInfo(params);
                        }else{
                            await API.enableWorkOrderLabelConfigInfo(params);
                        }
                        this.$message.success('操作成功');
                        this.getList();
                    } catch (error) {
                        this.$message.error(error.info);
                    }
                });
            },
            labelMoadl(row = {}) {
                const onSubmit = async (formData)=> {
                    if(row.id){
                        const params ={
                            ...formData,
                            id: row.id
                        };
                        await API.editWorkOrderLabelConfigInfo(params);
                    }else{
                        await API.saveWorkOrderLabelConfigInfo(formData);
                    }
                    vm.close();
                    this.$message.success('操作成功');
                    this.getList();
                }
                const { vm } = workOrderTagModal({
                    props: {
                        row
                    },
                    cbs: {
                        onSubmit
                    }
                })
            },
            async getList() {
                try {
                    this.dataLoading = true;
                    const { data } = await API.getWorkOrderLabelConfigList();
                    this.dataList = data
                } catch (error) {
                    this.$message.error(error.info);
                }finally {
                    this.dataLoading = false;
                }
            }
        },
    }
</script>

<style scoped>
.word-break {
    word-break:break-word;
}
</style>
